import React, { PureComponent } from 'react'
import img from '../Assets/contact/contact_img.png'
import { Button } from 'flowbite-react';
import e1 from '../Assets/contact/element.png';
import e2 from '../Assets/contact/element2.png';
import e3 from '../Assets/contact/element3.png';

const Contact = () => {
    const handleEmailClick = () => {
        window.location.href = 'mailto:5U5vA@example.com';
    }
    return (
        <>
            <section className="min-h-screen lg:min-h-screen flex items-center bg-yellow-50 bg-cover bg-no-repeat bg-center "
                loading="lazy" >
                <div className='container mx-auto text-[20px] text-gray-900'>

                    <div className='flex flex-col gap-y-5 lg:flex-row lg:items-center lg:gap-y-0'>

                        <div className='flex flex-1 flex-col text-center lg:text-left justify-center pt-[10%] sm:pt-[30%] md:pt-[15%] lg;pt-[10%] gap-y-4'>
                            <h2 className='font-primary text-[35px]'>Contact <span className='text-accent'>US </span></h2>
                            <h4 >For enquiries about our products and distribution requirements please call us with the number below.
                            </h4>
                            <h2 className='font-primary text-[35px] text-primary'>+971 6 74 87 538</h2>
                            <div className='flex gap-x-5 text-[15px] lg:text-left justify-center lg:justify-start '>
                                <div>
                                    <h3 className='text-[25px] font-bold'>
                                        Group of companies
                                    </h3>
                                    <ul className='pl-5 text-[20px]'>
                                        <li>Aryaa Sweets & Pastries LLC</li>
                                        <li>Aryaa Grains Packaging (Branch) LLC</li>
                                        <li>Aryaa Foods & Foodstuff Trading LLC</li>
                                        <li>Aryaa Foods Pvt Ltd, India</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="flex justify-center lg:justify-start lg:text-left">
    <Button class="btn flex items-center justify-center" onClick={handleEmailClick}>
        Send Email
    </Button>
</div>

                            <img className='absolute top-[20%] left-[20%]' src={e1} alt="" />
                            <img className='absolute top-[20%] left-[40%]' src={e1} alt="" />
                            <img className='absolute top-[40%] left-[40%]' src={e2} alt="" />
                            <img className='absolute bottom-[20%] left-[30%]' src={e3} alt="" />
                            <img className='absolute bottom-[35%] left-[40%]' src={e3} alt="" />
                            <img className='absolute top-[20%] right-[40%]' src={e3} alt="" />
                            <img className='absolute top-[25%] left-[28%]' src={e3} alt="" />



                        </div>
                        <div className='flex flex-1 justify-center items-center'>
                            <img src={img} loading="lazy" alt="" />
                        </div>
                    </div>

                </div>
            </section>

            <section className="min-h-screen lg:min-h-screen flex items-center bg-yellow-50 bg-cover bg-no-repeat bg-center ">
                <div className='container mx-auto text-[17px] text-gray-900'>
                    <div className='flex flex-col gap-y-5 lg:flex-row lg:items-center pb-5 lg:gap-y-0'>

                        <div className='relative lg:max-w-[30%] sm:max-w-[100%] pt-5 flex flex-1 text-center justify-center '>

                            {/* <div className="relative flex items-center justify-center w-full lg:order-2 lg:w-7/12"> */}
                            <div className="absolute left-[-10%] bottom-[-30%]  right-0 hidden lg:block">
                                <img className="object-contain w-auto h-48" src="https://cdn.rareblocks.xyz/collection/celebration/images/hero/3/curved-lines.png" alt="" />
                            </div>

                            <div className="relative sm:text-center lg:text-left">
                                <h1 className="text-3xl font-bold text-black xl:text-5xl">
                                    Companies Address
                                </h1>
                                <p className="mt-8 text-xl text-black">
                                    Aryaa Grains Packaging LLC P O Box 31201,<br />
                                    Ajman, UAE.<br />
                                    Telephone: <span className='text-primary font-extrabold' > +971 6 7487538  </span> <br />
                                    Fax: +971 6 7487539
                                </p>

                                <p className="mt-5 text-base text-black">Crafted with Care,  Served with Love</p>
                            </div>
                        </div>

                        {/* </div> */}
                        <div class="flex flex-1 text-center justify-center">
                            <iframe
                                class="w-full md:h-[550px] sm:h-[300px]"
                                frameborder="0"
                                marginheight="0"
                                marginwidth="0"
                                src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Aryaa%20Grains%20Packaging%20LLC%20P%20O%20Box%2031201+(Aryaa%20Foods)&amp;t=p&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                                loading="lazy"
                            >
                                <a href="https://www.gps.ie/">gps vehicle tracker</a>
                            </iframe>
                        </div>

                    </div>
                </div>
            </section>


        </>
    );
};

export default Contact;
